exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-header[data-v-8d2697b4]{background-color:#fbfbfb}.setting-body[data-v-8d2697b4]{background-color:#fdfdfd}.gravatar-pic[data-v-8d2697b4]{border-radius:50%;width:100px;display:initial;margin-bottom:6px}", ""]);

// exports
